/* eslint-disable no-param-reassign */
const riverdaliansAllowed = ['falcon', 'emerging-leader', 'founders', 'river-and-hill', 'maroon-and-gray', 'tall-oaks', 'head-of-school'];
const perkinsAllowed = ['consistent-a', 'consistent-b', 'consistent-c'];

// Detect if annual funds list is on page
const detectAnnualFund = () => {
  if (document.getElementById('annual-funds-load-more')) {
    return true;
  }
  return false;
};

// Function for toggling the loading states
const toggleLoadingState = (target) => {
  target.classList.toggle('loading');
  target.textContent = target.classList.contains('loading') ? 'Loading...' : 'Load More';
};

// increments current page data attribute by 1
const incrementCurrentPage = (target, currentPage) => {
  target.setAttribute('data-page', parseInt(currentPage, 10) + 1);
};

// checks if any more pages need loading
const pageLoadMoreCheck = (currentPage, totalPages) => {
  if (parseInt(currentPage, 10) + 1 === parseInt(totalPages, 10)) {
    return false;
  }
  return true;
};

// inserts new item nodes into the dom
const insertNewItems = (newItems) => {
  const annualFundsTable = document.querySelector('.wp-block-riverdale-annual-funds tbody');
  newItems.forEach((item) => {
    // build new tr
    const newTableRow = document.createElement('tr');
    const newTableData = document.createElement('td');

    // build listing data element
    const newSpanListing = document.createElement('span');
    newSpanListing.setAttribute('class', 'riverdale-annual-funds-listing');
    newSpanListing.textContent = item.meta.annual_funds_listing;
    newTableData.appendChild(newSpanListing);

    // build riverdalians symbol data elements
    if (item.terms['riverdalians-symbol'].length > 0) {
      const newSpanRiverdalians = document.createElement('span');
      newSpanRiverdalians.setAttribute('class', 'riverdale-annual-funds-riverdalians-images');

      item.terms['riverdalians-symbol'].forEach((riverdalianSymbol) => {
        if (!riverdaliansAllowed.includes(riverdalianSymbol.slug)) {
          return;
        }

        const newImage = document.createElement('img');
        newImage.setAttribute('src', `/wp-content/themes/riverdale/dist/static/images/${riverdalianSymbol.slug}.svg`);
        newImage.setAttribute('alt', riverdalianSymbol.name);
        newSpanRiverdalians.appendChild(newImage);
      });
      newTableData.appendChild(newSpanRiverdalians);
    }

    // build perkins symbol data elements
    if (item.terms['perkins-symbol'].length > 0) {
      const newSpanPerkins = document.createElement('span');
      newSpanPerkins.setAttribute('class', 'riverdale-annual-funds-perkins-images');
      item.terms['perkins-symbol'].forEach((perkinSymbol) => {
        if (!perkinsAllowed.includes(perkinSymbol.slug)) {
          return;
        }

        const newImage = document.createElement('img');
        newImage.setAttribute('src', `/wp-content/themes/riverdale/dist/static/images/${perkinSymbol.slug}.svg`);
        newImage.setAttribute('alt', perkinSymbol.name);
        newSpanPerkins.appendChild(newImage);
      });
      newTableData.appendChild(newSpanPerkins);
    }

    // build other giving symbol data elements
    if (item.terms['other-giving-symbol'].length > 0) {
      const newSpanGiving = document.createElement('span');
      newSpanGiving.setAttribute('class', 'riverdale-annual-funds-giving-images');
      item.terms['other-giving-symbol'].forEach((givingSymbol) => {
        if (givingSymbol.slug !== 'yes') {
          return;
        }

        const newImage = document.createElement('img');
        newImage.setAttribute('src', '/wp-content/themes/riverdale/dist/static/images/other-giving.svg');
        newImage.setAttribute('alt', 'other giving icon');
        newSpanGiving.appendChild(newImage);
      });
      newTableData.appendChild(newSpanGiving);
    }

    // insert node to dom
    newTableRow.appendChild(newTableData);
    annualFundsTable.insertAdjacentElement('beforeend', newTableRow);
  });
};

// Main function to run on load more click
const loadMoreItems = async (e) => {
  e.preventDefault();
  const {
    target,
    target: {
      dataset: {
        page: currentPage,
        items: itemsToGet,
        total: totalPages,
      },
    },
  } = e;

  toggleLoadingState(target);

  // Load the next set of items
  try {
    const response = await fetch(`/wp-json/wp/v2/annual-funds?_fields=terms,type,title,id,meta.annual_funds_listing&order=asc&orderby=title&per_page=${itemsToGet}&page=${parseInt(currentPage, 10) + 1}`);

    if (response.status !== 200) {
      throw new Error(`Status: ${response.status} ${response.statusText}`);
    }

    const newItems = await response.json();
    incrementCurrentPage(target, currentPage);
    insertNewItems(newItems);
  } catch (error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  // removes event listeners and button when last page has been reached
  if (!pageLoadMoreCheck(currentPage, totalPages)) {
    target.removeEventListener('click', loadMoreItems);
    target.remove();
    return;
  }

  toggleLoadingState(target);
};

if (detectAnnualFund()) {
  document.getElementById('annual-funds-load-more').addEventListener('click', loadMoreItems);
}
